var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import 'navigator.sendbeacon';
import { canUseDOM } from 'exenv';
import React, { createContext, useContext, useEffect } from 'react';
import * as Bowser from 'bowser';
var bufferLength = 1;
var buffer = [];
var STORAGE_TOKEN = 'session';
var STORAGE_TAB_TOKEN = 'tab';
var STORAGE_TIME_TOKEN = 'last_session_timestamp';
var STORAGE_PERMANENT_TOKEN = 'browser_id';
var now = new Date().getTime();
var differenceBetweenDates = 3600000; // ms, un'ora praticamente
var baseUrl = null;
var inited = false;
var targetSiteLocal = '';
var defaultUpdatePolicy = function (event, events) { return events.concat([event]); };
var updatePolicy = defaultUpdatePolicy;
var browser = {
    name: 'ssr',
    version: 1,
};
if (canUseDOM) {
    browser = Bowser.getParser(window.navigator.userAgent).getBrowser();
}
export var TrackingContext = createContext({ where: [] });
var generateToken = function () {
    return Math.random()
        .toString(36)
        .substring(2);
};
export var getSession = function () {
    return canUseDOM ? localStorage.getItem(STORAGE_TOKEN) : null;
};
export var getTab = function () {
    return canUseDOM ? sessionStorage.getItem(STORAGE_TAB_TOKEN) : null;
};
export var getBId = function () {
    return canUseDOM ? localStorage.getItem(STORAGE_PERMANENT_TOKEN) : null;
};
export function init(args) {
    bufferLength = args.bufferLength;
    baseUrl = args.baseUrl;
    inited = true;
    targetSiteLocal = args.targetSite;
    if (args.policy) {
        updatePolicy = args.policy;
    }
    if (!canUseDOM)
        return;
    if (!getBId()) {
        localStorage.setItem(STORAGE_PERMANENT_TOKEN, generateToken());
    }
    // genero un token a per la sessione in tab
    if (!getTab()) {
        sessionStorage.setItem(STORAGE_TAB_TOKEN, generateToken());
    }
    // controllo il token per il local storage {
    var isTooOld = !localStorage.getItem(STORAGE_TIME_TOKEN) ||
        now - Number(localStorage.getItem(STORAGE_TIME_TOKEN)) >
            differenceBetweenDates;
    if (!getSession() || isTooOld) {
        localStorage.setItem(STORAGE_TOKEN, generateToken());
    }
    localStorage.setItem(STORAGE_TIME_TOKEN, now.toString());
}
export var ExtendContext = function (_a) {
    var transformer = _a.transformer, children = _a.children;
    var context = useContext(TrackingContext);
    var Provider = TrackingContext.Provider;
    return React.createElement(Provider, { value: transformer(context), children: children });
};
export var WhereBlock = function (_a) {
    var step = _a.step, children = _a.children;
    return (React.createElement(ExtendContext, { transformer: function (context) { return (__assign(__assign({}, context), { where: __spreadArrays(context.where, [step]) })); }, children: children }));
};
/**
 * Blocco di comodo per utilizzare gli 'useEffect' all'interno di componenti
 * complessi che quindi non permetterebbero di impostare useEffect senza
 * scomporre il componente in diversi componenti
 */
export var ViewBlock = function (_a) {
    var event = _a.event, children = _a.children;
    var track = useTracking();
    useEffect(function () {
        track(event);
    }, []);
    return React.createElement(React.Fragment, null, children);
};
export var useTracking = function (overrides) {
    if (overrides === void 0) { overrides = {}; }
    var context = useContext(TrackingContext);
    return function (action, transformer) {
        var transformedContext = transformer ? transformer(context) : context;
        track(__assign(__assign(__assign({}, transformedContext), overrides), { action: action }));
    };
};
export function track(data) {
    if (!canUseDOM)
        return;
    if (!inited) {
        throw new Error('Called track before initialization');
    }
    var event = __assign(__assign({}, data), { timestamp: new Date(), who: __assign(__assign({}, data.who), { tabId: getTab(), sessionId: getSession(), browserId: getBId(), browserName: browser.name, browserVersion: browser.version }) });
    var newBuffer = updatePolicy(event, buffer);
    if (newBuffer.length === bufferLength) {
        buffer = [];
        send(newBuffer);
    }
    else {
        buffer = newBuffer;
    }
}
function send(chunk) {
    return __awaiter(this, void 0, void 0, function () {
        var obj, token;
        return __generator(this, function (_a) {
            // faccio l'invio dei dati solo se sono su client, su server e' inutile
            if (canUseDOM && baseUrl !== null) {
                try {
                    obj = { objs: chunk, targetSite: targetSiteLocal };
                    token = localStorage.getItem('auth_token');
                    if (token) {
                        obj.authorization = token;
                    }
                    navigator.sendBeacon(baseUrl, JSON.stringify(obj));
                }
                catch (e) {
                    console.error(e);
                    return [2 /*return*/, e];
                }
            }
            return [2 /*return*/];
        });
    });
}
if (canUseDOM) {
    window.addEventListener('unload', function () {
        if (buffer.length > 0) {
            send(buffer);
        }
    });
}
//# sourceMappingURL=index.js.map